module.exports = __webpack_public_path__ + "img/belgium-diabetes-mellitus-male.83b4a018.png";